<template>
  <o-view class="c-sales-view" :has-white-background="true" :no-scroll="true">
    <o-nav-bar
      title="Cambio-inschrijving"
      :has-back-button="true"
      :has-close-button="true"
      :is-overlay="true"
    />
    <o-message-header
      icon="check"
      text="Je inschrijving is gelukt"
      :success="true"
    />
    <o-section>
      <p>
        Cambio is je aanvraag aan het verwerken. Dit kan tot 2 werkdagen duren.
        Je hoeft geen verdere stappen te ondernemen.
      </p>
      <p>
        Van zodra je account geactiveerd is krijg je een bericht via mail.
      </p>
    </o-section>
  </o-view>
</template>

<script>
import OHeaderImage from '@/components/OHeaderImage.vue'
import OMessageHeader from '@/components/OMessageHeader.vue'
import OPayButton from '@/components/OPayButton.vue'
export default {
  name: 'CambioOnboardingConfirmation',
  components: {
    OHeaderImage,
    OMessageHeader,
    OPayButton
  },
  data() {
    return {
      showInfoOverlay: false,
      showSupportOverlay: false,
      showSaveButton: false
    }
  },
  methods: {
    toggleInfoOverlay() {
      this.showInfoOverlay = !this.showInfoOverlay
    },
    toggleSupportOverlay() {
      this.showSupportOverlay = !this.showSupportOverlay
    },
    closeAllOverlays() {
      this.showInfoOverlay = false
      this.showSupportOverlay = false
    },
    toggleSaveButton() {
      this.showSaveButton = true
    },
    cancelReservation() {
      console.log('test')
      if (window.confirm('Ben je zeker dat je de reservatie wil annuleren?')) {
        this.$router.push('/sales/car/cambio')
      }
    }
  }
}
</script>

<style lang="scss">
.c-sales-view {
  display: flex;
  flex-direction: column;
  min-height: 100%;

  .c-sales-sections {
    flex: 1 0 auto;
  }
}

.c-sales-details {
  padding: 0.8rem 0;
  position: relative;

  &:not(:last-child) {
    margin-bottom: 1.6rem;
  }
}

.c-sales-details__left,
.c-sales-details__right {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.c-sales-details__right {
  right: 0;
}

.c-sales-details__center {
  text-align: center;
}

.c-mobility-points {
  align-items: center;
  display: flex;
}

.c-mobility-points__icon {
  color: $primary-color;
  color: var(--primary-color);
}

.c-mobility-points__value {
  font-size: 1.3rem;
  margin-left: 0.8rem;
}

.c-price {
  color: $primary-color;
  color: var(--primary-color);
  font-size: 3.2rem;
  font-weight: 600;
  line-height: 3.2rem;
}

.c-price__sign {
  color: $gray-500;
  font-weight: 300;
  margin-right: 0.8rem;
}

.c-service {
  color: $gray-500;
  font-size: 1.3rem;
  margin-top: 0.8rem;
}

.c-bottom-overlay {
  background: #fff;
  border-radius: 1.2rem 1.2rem 0 0;
  box-shadow: $box-shadow-large, $box-shadow-large;
  bottom: 0;
  left: 0;
  max-height: 60vh;
  opacity: 0;
  overflow: auto;
  padding: 2.4rem;
  position: absolute;
  right: 0;
  transform: translateY(100%);
  transition: all 0.2s ease-in-out;
  z-index: 20;
}

.c-bottom-overlay__cover {
  background: rgba(#000, 0.4);
  bottom: 0;
  left: 0;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  right: 0;
  top: 0;
  transition: opacity 0.1s linear;
  z-index: 10;
}

.c-bottom-overlay__cover--show {
  opacity: 1;
  pointer-events: auto;
}

.c-bottom-overlay--open {
  opacity: 1;
  transform: translateY(0);
}

.c-bottom-overlay__title {
  font-weight: 600;
  margin-bottom: 1.6rem;
}

.c-bottom-overlay__text {
  line-height: 2.4rem;
  padding-right: 2.4rem;
}

.c-bottom-overlay__text:not(:last-child) {
  margin-bottom: 1.6rem;
}

.c-bottom-overlay__list {
  margin: 0 -1.6rem;
}

.c-bottom-overlay__close {
  cursor: pointer;
  position: absolute;
  right: 1.6rem;
  top: 1.6rem;
}
</style>
